import * as R from 'ramda'
// import { useLastOpenedRoomsStore } from './storage'
import {
  EventDeleteMessagesPayload,
  IMessage,
  Message,
} from '@weblite/ts-action/message'
import { LastOpenedRooms, LastOpenedRoomsStateType } from './types'
import { openedRoomMessagesStorage } from '$logic/opened-room/opened-room-messages.storage'
import { getOpenedRoomId } from '$logic/opened-room'
import {
  dispatchSetStore,
  dispatchInsert,
  dispatchEditMessage,
  dispatchRemoveRoom,
  dispatchDeleteMessage,
  dispatchClear,
  dispatchReplace,
} from './action'
import { getState } from '$setup/redux'
import { roomLastMessageStorage } from '$logic/room-last-message/storage'
import { openedRoomStorage } from '$logic/opened-room/opened-room.storage'

export const lastOpenedRoomMessagesService = {
  setStore(store: LastOpenedRoomsStateType): void {
    dispatchSetStore(store)
  },

  handleNewMessages(messages: Message[]): void {
    R.toPairs(R.groupBy(R.prop('roomId'), messages)).forEach(
      ([roomId, messages]) => {
        const roomLastMessageState = roomLastMessageStorage.getSync(roomId)
        if (!roomLastMessageState.calculatedAt) return

        const sortedMessagesToInsert = R.sortBy(R.prop('iid'), messages)

        const oldCachedMessages =
          lastOpenedRoomMessagesService.getLastOpenedRoomMessagesByRoomId(
            roomId,
          )?.messages

        if (
          roomLastMessageState.lastMessage &&
          roomLastMessageState.lastMessage.iid !==
            R.last(oldCachedMessages || [])?.iid
        )
          return

        dispatchInsert(roomId, sortedMessagesToInsert)
      },
    )
  },

  editLastOpenedRoomMessages(
    patch: Pick<IMessage, 'iid' | 'roomId' | 'body' | 'attachment'>[],
  ): void {
    patch.forEach(({ roomId, iid, ...updatedFields }) => {
      dispatchEditMessage(roomId, iid, updatedFields)
    })
  },

  getLastOpenedRoomMessageStore(): LastOpenedRoomsStateType {
    return getState().main.lastOpenedRoomMessages
  },

  getLastOpenedRoomMessagesByRoomId(
    roomId: string,
  ): LastOpenedRooms | undefined {
    return getState().main.lastOpenedRoomMessages[roomId]
  },

  removeRoomFromLastOpenedRoomMessages(roomId: string): void {
    dispatchRemoveRoom(roomId)
  },

  handleDeletePatches(patch: EventDeleteMessagesPayload): void {
    dispatchDeleteMessage(patch)
  },

  clearLastOpenedRooms(): void {
    dispatchClear()
  },

  syncOpenedRoomWithLastOpenedRoomMessages() {
    const roomId = getOpenedRoomId()
    if (!roomId || openedRoomStorage.getLoading()) return

    const openedRoomMessages = openedRoomMessagesStorage.getAll()

    dispatchReplace(roomId, openedRoomMessages)
  },
}
